<article class="flex flex-row bg-[--neutral-300] py-1.5">
  @for (label of chipLabels(); track $index) {
    <span
      class="flex flex-1 items-center justify-center px-2 font-medium text-xs text-[--color-text-icon-primary] border-r border-[--color-text-icon-secondary] last-of-type:border-r-0"
      >{{ label }}</span
    >
  }
</article>
